module.exports = __webpack_public_path__ + "static/media/rachmastrivke.277c4ac5.jpg";